module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v("This paged does not exist.")]), _vm._v(" "), _c('p', [_vm._v("Please check the following:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Make sure you opened this page by navigating to ERPLY backoffice.")]), _vm._v(" "), _c('li', [_vm._v("Make sure the user you are logged in with has administrator privileges.")]), _vm._v(" "), _c('li', [_vm._v("If you have kept the browser window opened for long time, then please refresh.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1416b39a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Error/404.vue
// module id = 1671
// module chunks = 1